import {SlBrandingGateComponent} from '@screenleads/branding';
import {CompanyThemeService} from './core/services/company-theme.service';
import { slText } from '@screenleads/i18n';
import { SlI18nModule } from '@screenleads/i18n';
import { SlToastContainerComponent } from 'sl-dev-components';
import { SlDashboardModule } from 'sl-dev-components';
import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';




import { AuthStore } from './core/store/auth.store';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [SlBrandingGateComponent,SlToastContainerComponent,
    RouterOutlet,
    SlDashboardModule,SlI18nModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly authStore = inject(AuthStore);
  readonly companyTheme=inject(CompanyThemeService);
  title=slText('sl-dev-deshboard');
  constructor(){
    effect(()=>{this.companyTheme.loadCompanyTheme(this.authStore.companyId() ?? 1);});
  }
}
